import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

export const LargerTooltip = withStyles({
	tooltip: {
		fontSize: 13,
	}
})(Tooltip);
